/**
 * Get Recent Sessions Use Case
 * Fetches recently completed charging sessions
 */

import { DashboardRepository } from '../data/dashboard-repository';
import { RecentSession } from '../types/dashboard-types';

export class GetRecentSessionsUseCase {
  constructor(private readonly repository: DashboardRepository) {}

  async execute(
    page: number = 0,
    pageSize: number = 50,
    hours: number = 24
  ): Promise<{
    sessions: RecentSession[];
    totalCount: number;
    totalPages: number;
    hasError: boolean;
    errorMessage?: string;
  }> {
    try {
      const result = await this.repository.getRecentSessions(page, pageSize, hours);

      return {
        sessions: result.sessions,
        totalCount: result.totalCount,
        totalPages: Math.ceil(result.totalCount / pageSize),
        hasError: false,
      };
    } catch (error) {
      console.error('GetRecentSessionsUseCase.execute failed:', error);

      return {
        sessions: [],
        totalCount: 0,
        totalPages: 0,
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to load recent sessions',
      };
    }
  }
}
